import { call, fork, put, take } from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {enqueueErrorSnackbar, enqueueSuccessSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import {Api} from '../api';
import Logger from '../common/logger';
import {RebookCustomerDoorPayload, fetchBookingDetails, rebookCustomerDoor} from '../action/bookingsCommands';
import {RebookCustomerDoorResult} from '../api/types';

const onRebookCustomerDoor = function*(bookingId: string, depotId: string, orderItemId: string, doorNumber: number) {
    try {
        const result: RebookCustomerDoorResult = yield call(
            Api.rebookCustomerDoor, bookingId, depotId, orderItemId, doorNumber,
        );

        yield put(enqueueSuccessSnackbar({
            message: getI18n().t(
                'snackbar.success.rebook_customer_door',
                { oldDoor: result.oldDoor, newDoor: result.newDoor },
            ),
        }));

        yield put(fetchBookingDetails({ bookingId }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({
            message: getI18n().t('snackbar.error.rebook_customer_door'),
        }));
    }
};

export function* rebookCustomerDoorFlow() {
    while (true) {
        const action: Action<RebookCustomerDoorPayload> = yield take(rebookCustomerDoor.toString());

        yield fork(
            onRebookCustomerDoor,
            action.payload.bookingId,
            action.payload.depotId,
            action.payload.orderItemId,
            action.payload.doorNumber,
        );
    }
}
